var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMjmJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wy95r9rt7a",
    x1: 0.545,
    y1: 0.31,
    x2: 0.199,
    y2: 0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0bxcfc4dxb",
    x1: 0.5,
    y1: 0.59,
    x2: 0.618,
    y2: 1.299,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hfrvy9dxvc",
    x1: 0.5,
    x2: 0.5,
    y2: 1.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8srsa9c5jd",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#wy95r9rt7a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7foayl4sje",
    x1: 0.5,
    y1: 0.411,
    x2: 0.049,
    y2: 0.866,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#04739e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 168",
    d: "M3.6 1.919a1.679 1.679 0 1 0 0 3.358h8.316a1.679 1.679 0 0 0 0-3.358H3.6M3.6 0h8.316a3.6 3.6 0 1 1 0 7.2H3.6a3.6 3.6 0 0 1 0-7.2z",
    transform: "translate(11.788 6.26)",
    style: {
      fill: "url(#wy95r9rt7a)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 166",
    width: 26.604,
    height: 18.491,
    rx: 9.245,
    transform: "translate(6.315 9.858)",
    style: {
      fill: "url(#0bxcfc4dxb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 18",
    d: "M3.3 1.913a1.3 1.3 0 0 0-1.317 1.276V15.3A1.3 1.3 0 0 0 3.3 16.577h20a1.3 1.3 0 0 0 1.321-1.277V3.189A1.3 1.3 0 0 0 23.3 1.913h-20M3.3 0h20a3.248 3.248 0 0 1 3.3 3.189V15.3a3.249 3.249 0 0 1-3.3 3.189h-20A3.248 3.248 0 0 1 0 15.3V3.189A3.248 3.248 0 0 1 3.3 0z",
    transform: "translate(6.315 9.858)",
    style: {
      fill: "url(#hfrvy9dxvc)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 132",
    transform: "translate(21.013 20.764)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 5",
    d: "M-7.56-2.124a1.434 1.434 0 0 1-1.018-.422 1.439 1.439 0 0 1 0-2.035l4-4a1.439 1.439 0 0 1 2.036 0 1.439 1.439 0 0 1 0 2.035l-4 4a1.434 1.434 0 0 1-1.018.422z",
    transform: "translate(8.999 17.077)",
    style: {
      fill: "url(#8srsa9c5jd)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 31",
    cx: 5.758,
    cy: 5.757,
    rx: 5.758,
    ry: 5.757,
    transform: "translate(3.039)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 31 - Outline",
    d: "M5.758 1.919A3.838 3.838 0 1 0 9.6 5.757a3.838 3.838 0 0 0-3.842-3.838m0-1.919A5.757 5.757 0 1 1 0 5.757 5.757 5.757 0 0 1 5.758 0z",
    transform: "translate(3.039)",
    style: {
      fill: "url(#7foayl4sje)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 187",
    width: 26.604,
    height: 9.396,
    rx: 4.698,
    transform: "translate(6.315 9.858)",
    style: {
      fill: "url(#8srsa9c5jd)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 167",
    width: 4.964,
    height: 6.889,
    rx: 2.482,
    transform: "rotate(90 3.438 19.58)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjmJobs);
export default __webpack_public_path__ + "static/media/MJM-Jobs.4c2e0c509e0d28953d59bdd03f2eb930.svg";
export { ForwardRef as ReactComponent };